import { LobbyUiContext } from '@/contexts/LobbyUiContext';
import { ScreenContext } from '@/contexts/ScreenContext';
import { Setting as SettingButton } from '@/modules/setting';
import { getVHByRem } from '@/utils/commonFunc';
import { default as Box, default as Grid } from '@mui/material/Grid';
import { useContext, useEffect, useState } from 'react';
import { Banner } from '../Banner';
import { GameTypeFilter } from '../GameTypeFilter';
import { GridToggle } from '../GridToggle';
import { HeaderInfo } from './HeaderInfo';
import './index.scss';
export const Header = () => {
    const { isLandscape } = useContext(ScreenContext);

    const { isShowGridToggle, isShowGameFilter } = useContext(LobbyUiContext);

    const [iconHeight, setIconHeight] = useState<string>('2.875rem');
    useEffect(() => {
        setIconHeight(isLandscape ? getVHByRem(1.875) : '2.875rem');
    }, [isLandscape]);
    return (
        <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            className="lobby-header"
            flexWrap={'nowrap'}
            sx={{ gap: 'calc(var(--vw) * 2)' }}
        >
            <Grid item sx={{ flexGrow: 1, width: 0 }}>
                <Grid
                    container
                    height={iconHeight}
                    direction="row"
                    alignItems={'center'}
                    gap={'1rem'}
                    flexWrap={'nowrap'}
                >
                    <Grid
                        item
                        height={iconHeight}
                        display={'flex'}
                        width={'fit-content'}
                    >
                        <Banner />
                    </Grid>
                    <Box
                        className="game-type-filter-container"
                        display={
                            isLandscape && isShowGameFilter ? 'block' : 'none'
                        }
                        sx={{ flexGrow: 1, width: 0 }}
                    >
                        <GameTypeFilter />
                    </Box>
                </Grid>
            </Grid>
            <Grid item>
                <Grid
                    container
                    direction="row"
                    alignItems={'center'}
                    wrap="nowrap"
                >
                    <Box
                        padding={'var(--vh)'}
                        display={
                            isLandscape && isShowGridToggle ? 'block' : 'none'
                        }
                    >
                        <GridToggle />
                    </Box>
                    <HeaderInfo />
                    <SettingButton />
                </Grid>
            </Grid>
        </Grid>
    );
};
